export interface T_Options {
  name: String;
  value: String;
}
export enum ServiceStatus {
  DataPendingOrder = -1,
  Active = 1,
  Disconnected = 2,
  PendingInstall = 3,
  PendingDisconnect = 4,
}
export interface T_Channel {
  logoThumbnail: string;
  sort: string;
  synopsis: string;
  url: string;
  number: string;
  logoInverted: string;
  promotionIntro: string;
  name: string;
  genre: string[];
  logo: string;
  hd: string;
  sku: string;
  order: string;
}
export interface T_Product {
  name: string;
  id: number;
  sku: string;
  url: string;
  idInCart: number;
  categoryId: number;
  categoryName: string;
  selected?: boolean;
  depends?: number[];
  accessories: number[];
  // Description to show when want to buy product
  description: string;
  // Description to show when product owned
  comparison: string;
  priceIncTax: number;
  priceBilled?: number;
  quantityInCart: number;
  quantityBought: number;
  image: string;
  prodRelationTypeArray: number[];
  // URL.
  custom1: string;
  // Upsell offer code.
  custom2: string;
  // Additional ICOMS codes (e.g. for boxes).
  custom3: string | null;
  // Whether ACQUISITION or UPGRADE (e.g. for boxes).
  custom4: string;
  // Legacy - things we no longer sell
  custom5: string;
  // Terms and conditions URL - free product
  custom6: string;
  // Upgradable boxes: service codes : separated by colon where everything before is too add and everything after is to remove e.g. 618,614,612:620,615
  custom7: string | null;
  // 'Short' description. e.g. for broadband products 'Up to 900Mbps'
  custom8: string | null;
  custom9: string | null;
  custom10: string | null;
  // Original price
  price0: number;
  // Special price
  price1: number;
  price3: number;
  rating: number;
  promotionTitle: string;
  downgrade?: boolean;
  model?: string;
  inPromotion?: boolean;
  serviceStatus?: ServiceStatus;
  // Additional fields from LR.
  videoUrl?: string;
  horizontalVideoUrl?: string;
  logoImageUrl?: string;
  explorePopupCopy?: string;
  horizontalImageUrl?: string;
  contractDescription?: string;
  showExplorePopup?: boolean;
  linkLabel?: string;
  linkUrl?: string;
  iconImageUrl?: string[];
  iconImageUrlFromJSON?: any;
  channels: T_Channel[];
  occurrenceNumber?: string;
  broadbandPriceHold?: boolean;
  isPhantom?: boolean;
  popupCards?: any;
}
export interface T_BasketItem {
  id: number;
  finalPriceExTax: number;
  finalPriceIncTax: number;
  product: T_Product;
  quantity: number;
  productId: number;
  downgrade: boolean;
  inPromotion: boolean;
  currentlySubscribed: boolean;
  occurrenceNumber?: string;
  broadbandPriceHold?: boolean;
  isPhantom?: boolean;
}
export type T_OrderRequest = Pick<
  T_BasketItem,
  | 'productId'
  | 'quantity'
  | 'finalPriceIncTax'
  | 'downgrade'
  | 'inPromotion'
  | 'currentlySubscribed'
  | 'occurrenceNumber'
  | 'broadbandPriceHold'
  | 'isPhantom'
>;
// export interface Product {
//               "id": number;
//               "customObj": string | null;
//               "storeId": string;
//               "quantity": number;
//               "extQuantity": number | null;
//               "quantityReserved": number;
//               "model": string;
//               "image": string;
//               "image2": string;
//               "image3": string;
//               "image4": string;
//               "images": string | null;
//               "imageDir": string;
//               "imageCrc": null,
//               "priceExTax": number,
//               "specialPriceExTax": number | null;
//               "priceIncTax": number;
//               "specialPriceIncTax": number | null;
//               "dateAvailable": any;
//               "dateAdded": any,
//               "expiryDate": null,
//               "weight": number,
//               "weightUOM": string;
//               "length": number;
//               "width": number;
//               "depth": number;
//               "sizeUOM": string;
//               "status": number;
//               "invisible": number;
//               "name": string;
//               "manufacturerName": string;
//               "manufacturerId": number;
//               "manufacturer": string | null;
//               "categoryId": number;
//               "addresses": string | null;
//               "description": "Lots to enjoy, from kids shows to music, action, food and lifestyle",
//               "comparison": "",
//               "url": "https://www.sky.co.nz/discover/sky-starter",
//               "customd1": "",
//               "customd2": "",
//               "customd3": "",
//               "customd4": "",
//               "customd5": "",
//               "customd6": "",
//               "viewedCount": 0,
//               "numberReviews": 0,
//               "taxClassId": 1,
//               "taxCode": null,
//               "sku": "202",
//               "filePath": null,
//               "contentType": null,
//               "maxNumDownloads": -1,
//               "maxDownloadDays": -1,
//               "stockReorderLevel": -1,
//               "type": 1,
//               "opts": null,
//               "ordered": 0,
//               "specialExpiryDate": null,
//               "specialStartDate": null,
//               "specialStatus": 0,
//               "prodRelationTypeArray": null,
//               "customAttrs": "",
//               "customAttrArray": null,
//               "templateId": -1,
//               "custom1": "https://static.sky.co.nz/sky/cart/jul/Sky-Starter-July-My-Account.jpg",
//               "custom2": "01269",
//               "custom3": null,
//               "custom4": null,
//               "custom5": null,
//               "custom6": null,
//               "custom7": null,
//               "custom8": null,
//               "custom9": null,
//               "custom10": null,
//               "custom1Int": 0,
//               "custom2Int": 0,
//               "custom1Dec": null,
//               "custom2Dec": null,
//               "storeCustom1": null,
//               "storeCustom2": null,
//               "storeCustom3": null,
//               "price0": 25.99,
//               "price1": null,
//               "price2": null,
//               "price3": null,
//               "tags": [],
//               "tierPrices": null,
//               "bundledProdQuantity": 0,
//               "encodedOptionValues": null,
//               "canOrderWhenNotInStock": null,
//               "priceId": -1,
//               "indexAttachment": false,
//               "snippets": null,
//               "extPrice0": null,
//               "extPrice1": null,
//               "extPrice2": null,
//               "extPrice3": null,
//               "extDateAvailable": null,
//               "rating": 1000,
//               "productQuantities": null,
//               "ignoreProductQuantityStock": false,
//               "paymentSchedule": null,
//               "paymentScheduleId": -1,
//               "bookableProd": null,
//               "miscItems": null,
//               "miscPrices": null,
//               "promotionResults": null,
//               "uuid": "9A8C6949-3022-4B85-873F-B966982F3C38",
//               "bundledProducts": null,
//               "searchScore": null,
//               "storeName": null,
//               "storeDescription": null,
//               "suggestions": null,
//               "quantityAvailable": 0

// }
export interface T_OrderProduct {
  customersbaskettempid: number;
  id: number;
  productId: number;
  quantity: number;
  product: any;
  price: number;
  promotionTitle: string;
  categoryName: string;
  categoryId: number;
  rating: number;
  opts?: T_Options[] | null;
  accessories?: number[];
  depends?: number[];
  downgrade?: boolean;
  inPromotion?: boolean;
  currentlySubscribed?: boolean;
  occurrenceNumber?: string;
  finalPriceIncTax?: number;
  broadbandPriceHold?: boolean;
  isPhantom?: boolean;
  finalPriceExTax: number | null;
}
export interface T_OrderTotal {
  className: string;
  freeProductId: number;
  id: number;
  orderId: number;
  value: number;
  title: string;
  promotionId: number;
  promotions?: {
    name: string;
  }[];
}
export interface T_Order {
  couponDetails?: T_Coupon[];
  orderTotals: T_OrderTotal[];
  orderProducts: T_OrderProduct[];
  customerId: string;
}

export interface T_Order {
  orderTotals: T_OrderTotal[];
  orderProducts: T_OrderProduct[];
  customerId: string;
}
export interface T_OrderWithCoupon {
  order: T_Order;
  coupon: T_Coupon;
}
export interface T_Coupon {
  name: string;
  id: number | string;
  couponCode: string;
  custom1: string;
  custom2: string;
  custom3: string;
  custom4: string;
  custom5: string;
  description: string;
  maxUse?: any;
  timesUsed?: number;
  dateAdded?: string;
  lastModified?: any;
}

export interface T_CouponRetrieval {
  r: T_Coupon[];
}
